import { useState, useEffect } from "react";
import { IoChevronBackOutline } from "react-icons/io5";
import { IoIosAddCircleOutline } from "react-icons/io";
import { getAssignNames } from "../../../../Service/partnerAPI";
import { getLookupData } from "../../../../Service/lookup";
import TwelveHourTimePicker from "../../../../reusableUI/twelhrspicker";
import moment from "moment";
import { BookingAppointment } from "../../../../Service/partnerAPI";
import { showToast } from "../../../../reusableUI/toaster";
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";
import { MdDeleteOutline } from "react-icons/md";
import { FiEdit } from "react-icons/fi";

const StaffScheduling = () => {
  const [activeTab, setActiveTab] = useState("assignment");
  const [patient, setPatient] = useState("");
  const [nurse, setNurse] = useState("");
  const [dutyType, setDutyType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [assignments, setAssignments] = useState([]);
  const [patients, setPatients] = useState([]);
  const [specialists, setSpecialists] = useState([]);
  const [dutyTypes, setDutyTypes] = useState([]);
  const [casedata, setCase] = useState([]);
  const [timeSlot, setTimeSlot] = useState("");
  const [startTime247, setStartTime247] = useState("");
  const [nurseId, setNurseId] = useState("");
  const [patientId, setPatientId] = useState("");
  const [duration, setDuration] = useState("");
  const tomorrow = moment().add(1, "days").format("YYYY-MM-DD");
  const [totalDays, setTotalDays] = useState();
  const [toastMsg, setToastMsg] = useState(null);

  const navigate = useNavigate();

  console.log(nurse);

  useEffect(() => {
    getNames();
    getCase();
  }, []);

  useEffect(() => {
    let daysToAdd = 0;

    if (duration) {
      const lowerDuration = duration.toLowerCase();

      if (lowerDuration.includes("1 Day")) {
        daysToAdd = 0;
      } else if (lowerDuration.includes("3 days")) {
        daysToAdd = 2;
      } else if (lowerDuration.includes("1 week")) {
        daysToAdd = 6;
      } else if (lowerDuration.includes("2 weeks")) {
        daysToAdd = 13;
      } else if (
        lowerDuration.includes("3 week") ||
        lowerDuration.includes("4 week") ||
        lowerDuration.includes("more")
      ) {
        daysToAdd = 29;
      }

      setTotalDays(daysToAdd + 1);
    }

    const newToDate = moment(fromDate)
      .add(daysToAdd, "days")
      .format("YYYY-MM-DD");

    setToDate(newToDate);
  }, [duration, fromDate]);

  const validateAndSetDate = (value, setter) => {
    const date = moment(value);
    if (
      !value ||
      !date.isValid() ||
      date.isBefore(moment().add(1, "days"), "day")
    ) {
      setter(tomorrow);
    } else {
      setter(date.format("YYYY-MM-DD"));
    }
  };

  const getNames = async () => {
    try {
      const result = await getAssignNames();
      if (result?.data) {
        console.log(result.data);
        setPatients(result.data.patients);
        setSpecialists(result.data.specialists);
        setDutyTypes(result.data.dutyTypes.regularShifts.slots);
      }
    } catch (error) {
      console.error("Error fetching assignment data:", error);
    }
  };

  const getCase = async () => {
    const result = await getLookupData();
    if (!result.error) {
      setCase(result.data);
    }
  };

  const selectedDuty = dutyType ? JSON.parse(dutyType) : null;

  let selectedShiftData = null;
  if (selectedDuty) {
    const { shift, type } = selectedDuty;
    if (shift === "morning" && type === "9H")
      selectedShiftData = "morningShift9Data";
    else if (shift === "morning" && type === "12H")
      selectedShiftData = "morningSHift12Data";
    else if (shift === "night" && type === "12H")
      selectedShiftData = "nightShift12Data";
    else if (shift === "24/7") selectedShiftData = "24/7";
  }

  const caseList = casedata.filter((item) => item.type === selectedShiftData);
  const durationList = casedata.filter((item) => item.type === "dutyTimeData");

  const handleAssign = () => {
    if (!patient) {
      showToast("Please select a patient.", "Error");
      return;
    }

    if (!nurse) {
      showToast("Please select a nurse.", "Error");
      return;
    }

    if (!dutyType) {
      showToast("Please select a duty type.", "Error");
      return;
    }

    if (!fromDate) {
      showToast("Please select a start date.", "Error");
      return;
    }

    if (!toDate) {
      showToast("Please select an end date.", "Error");
      return;
    }

    if (!timeSlot && !startTime247) {
      showToast(
        "Please select a time slot or start time for 24/7 duty.",
        "Error"
      );
      return;
    }

    const newAssignment = {
      patientId: patientId,
      specialistId: nurseId,
      patient,
      nurse,
      dutyType: JSON.parse(dutyType),
      fromDate: fromDate,
      toDate: toDate,
      timeSlot: selectedDuty?.shift === "24/7" ? startTime247 : timeSlot,
      slotDuration: duration,
    };

    setAssignments([...assignments, newAssignment]);
    setPatient("");
    setNurse("");
    setDutyType("");
    setFromDate("");
    setToDate("");
    setTimeSlot("");
    setStartTime247("");
    setNurseId("");
    setPatientId("");
    setDuration("");

    showToast("Booking Assigned Successfully", "Success");
  };

  const handleBack = () => {
    secureLocalStorage.setItem("back", "Assigned Staffs");
    navigate("/partner/careteams");
  };

  const Submit = async () => {
    if (assignments.length === 0) {
      window.alert(
        "No bookings to assign. Please add at least one assignment."
      );
      showToast(
        "No bookings to assign. Please add at least one assignment.",
        "Error"
      );
      return;
    }

    // ✅ Confirmation alert before submission
    const confirm = window.confirm(
      "Are you sure you want to submit the booking?"
    );
    if (!confirm) {
      return;
    }

    const data = assignments.map((item) => {
      const patientInfo = patients.find((p) => p.id === item.patientId);
      const specialistInfo = specialists.find(
        (s) => s.id === item.specialistId
      );

      const dutyFee = dutyTypes.find(
        (i) =>
          i.shift === item.dutyType?.shift && i.type === item.dutyType?.type
      )?.fee;

      return {
        patient: {
          name: patientInfo?.name || "",
          gender: patientInfo?.gender || "",
          type: patientInfo?.type || "",
          relationship: patientInfo?.relationship || "",
          userID: patientInfo?.userID || "",
          patientID: patientInfo?.patientID || "",
          profilePicture: patientInfo?.profilePicture || "",
        },
        specialistInfo: {
          name: specialistInfo?.name || "",
          role: specialistInfo?.role || "",
          userID: specialistInfo?.id || "",
          gender: specialistInfo?.gender || "",
        },
        dutyType: "regular",
        visitInfo: {
          shiftType: item.dutyType
            ? `${item.dutyType.shift},${item.dutyType.type}`
            : "",
          startDate: new Date(item.fromDate),
          endDate: new Date(item.toDate),
          slot: item.timeSlot,
          duration: duration,
          addressInfo: patientInfo?.address,
          days: totalDays,
          feePerDay: Number(dutyFee) || 0,
          fees: totalDays * Number(dutyFee),
        },
      };
    });

    try {
      const res = await BookingAppointment(data);

      if (res.error === false) {
        showToast("Booking Assigned Successfully", "Success");
        setAssignments([]);
        setTimeout(() => {
          handleBack();
        }, 600);
      } else {
        console.log("error", res.error);
      }
    } catch {
      console.log("error");
    }
  };

  // console.log(patient, patientId);

  // console.log(duration);

  console.log(durationList);

  const handleEdit = (item, index) => {
    console.log(item);
    setPatient(item.patient);
    setNurse(item.nurse);
    setDutyType(JSON.stringify(item.dutyType));
    setFromDate(item.fromDate);
    setToDate(item.toDate);
    setTimeSlot(item.timeSlot);
    setStartTime247(item.timeSlot);
    setPatientId(item.patientId);
    setNurseId(item.specialistId);
    setDuration(item.slotDuration);

    const updatedAssignments = assignments.filter((_, i) => i !== index);
    setAssignments(updatedAssignments);
  };

  const handleDelete = (item, index) => {
    const updatedAssignments = assignments.filter((_, i) => i !== index);
    setAssignments(updatedAssignments);
  };

  return (
    <div className="h-[88vh] overflow-y-auto flex flex-col shadow-lg rounded-2xl bg-white p-4 m-2">
      {/* Back Button */}
      <div className="w-full mb-2">
        <button
          className="text-indigo-600 text-[13px] font-poppins hover:underline flex items-center"
          onClick={handleBack}
        >
          <IoChevronBackOutline size={20} className="mr-1" /> Back
        </button>
      </div>

      <div className="text-center mb-4">
        <h2 className="text-[14px] text-indigo-600 font-poppins">
          Staff Scheduling & Assignment
        </h2>
      </div>

      {/* Tabs */}
      <div className="flex justify-center mb-6">
        <button
          className={`px-16 py-1 rounded-l-lg font-poppins transition text-[12px] ${activeTab === "assignment"
              ? "bg-indigo-600 text-white"
              : "bg-indigo-100 text-indigo-600"
            }`}
          onClick={() => setActiveTab("assignment")}
        >
          Assignment
        </button>
        <button
          className={`px-10 py-1 rounded-r-lg font-poppins transition text-[12px] ${activeTab === "backup"
              ? "bg-indigo-600 text-white"
              : "bg-indigo-100 text-indigo-600"
            }`}
          onClick={() => setActiveTab("backup")}
        >
          Back-Up / On-Call
        </button>
      </div>

      {/* Assignment Form */}
      <div className="w-full max-h-[80vh] overflow-y-auto px-2">
        <div className="bg-white rounded-2xl w-[60%] max-w-4xl p-6 mx-auto">
          <div className="bg-white border flex flex-row justify-center items-center rounded-xl p-6">
            <div className="flex flex-col w-[80%] gap-2 mb-4">
              {/* Patient */}
              <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
                <label className="block min-w-[150px] text-[12px] font-medium mb-1 font-poppins">
                  Patient
                </label>
                <select
                  value={patientId} // Store selected patient ID here
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    setPatientId(selectedId);
                    const selectedPatient = patients.find(
                      (item) => item.id === selectedId
                    );
                    setPatient(selectedPatient ? selectedPatient.name : "");
                  }}
                  className="w-full sm:w-[350px] border border-[#D2D2D2] rounded text-[12px] px-3 py-1 font-poppins"
                >
                  <option hidden>Select Patient</option>
                  {patients.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Nurse */}
              <div className="flex flex-row justify-between items-center mb-4">
                <label className="block min-w-[150px] text-[12px] font-medium mb-1 font-poppins">
                  Nurse
                </label>
                <select
                  value={nurseId} // Store selected nurse ID here
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    setNurseId(selectedId);
                    const selectedNurse = specialists.find(
                      (item) => item.id === selectedId
                    );
                    setNurse(selectedNurse ? selectedNurse.name : "");
                  }}
                  className="w-full sm:w-[350px] border border-[#D2D2D2] rounded text-[12px] px-3 py-1 font-poppins"
                >
                  <option hidden>Select Nurse</option>
                  {specialists.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Duty Type */}
              <div className="flex flex-row justify-between items-center mb-4">
                <label className="block min-w-[150px] text-[12px] font-medium mb-1 font-poppins">
                  Duty Type
                </label>
                <select
                  value={dutyType}
                  onChange={(e) => setDutyType(e.target.value)}
                  className="w-[350px] text-[12px] border border-[#D2D2D2] rounded px-3 py-1 font-poppins"
                >
                  <option hidden>Select Duty Type</option>
                  {dutyTypes.map((item, index) => (
                    <option
                      key={index}
                      value={JSON.stringify({
                        shift: item.shift,
                        type: item.type,
                      })}
                    >
                      {item.shift === "24/7" && item.type === "24/7"
                        ? "24/7"
                        : `${item.shift} , ${item.type}`}
                    </option>
                  ))}
                </select>
              </div>

              {/* Time Slot or Picker */}
              {selectedDuty?.shift !== "24/7" ? (
                <div className="flex flex-row justify-between items-center mb-4">
                  <label className="block min-w-[150px] text-[12px] font-medium mb-1 font-poppins">
                    Time Slot
                  </label>
                  <select
                    value={timeSlot}
                    onChange={(e) => setTimeSlot(e.target.value)}
                    className="w-[350px] text-[12px] border border-[#D2D2D2] rounded px-3 py-1 font-poppins"
                  >
                    <option hidden>Select Time Slot</option>
                    {caseList.map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.value}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                <TwelveHourTimePicker
                  value={startTime247}
                  onChange={setStartTime247}
                />
              )}

              <div className="flex flex-row justify-between items-center mb-4">
                <label className="block min-w-[150px] text-[12px] font-medium mb-1 font-poppins">
                  Slot Duration
                </label>
                <select
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                  className="w-[350px] text-[12px] border border-[#D2D2D2] rounded px-3 py-1 font-poppins"
                >
                  <option hidden>Select Slot Duration</option>
                  {durationList.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block mt-4 text-[13px] font-semibold mb-3 font-poppins">
                  Assignment Date
                </label>
                <div className="flex space-x-2 items-center">
                  <p className="text-blue-600 text-[13px] font-semibold">
                    From
                  </p>
                  <input
                    type="date"
                    min={tomorrow}
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    onBlur={(e) =>
                      validateAndSetDate(e.target.value, setFromDate)
                    }
                    className="w-[250px] border border-[#D2D2D2] text-[12px] rounded px-3 py-1"
                  />

                  <p className="text-blue-600 text-[13px] font-semibold">To</p>
                  <input
                    type="date"
                    min={tomorrow}
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    onBlur={(e) =>
                      validateAndSetDate(e.target.value, setToDate)
                    }
                    className="w-[250px] border border-[#D2D2D2] text-[12px] rounded px-3 py-1"
                  />
                  <div className="text-right">
                    <button
                      onClick={handleAssign}
                      className="bg-indigo-600 min-w-[150px] hover:bg-indigo-700 font-poppins text-[13px] text-white px-2 py-1 rounded shadow inline-flex items-center"
                    >
                      Assign Nurse
                      <IoIosAddCircleOutline size={18} className="ml-2" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Assigned List Table */}
        <div className="mt-6 w-[60%] mx-auto">
          <h3 className="text-[14px] font-semibold mb-2 font-poppins text-indigo-600">
            Assigned Nurses List
          </h3>
          <table className="w-full text-[12px] font-poppins border">
            <thead>
              <tr className="bg-indigo-100 text-indigo-700 text-left">
                <th className="p-2 border">Patient</th>
                <th className="p-2 border">Nurse</th>
                <th className="p-2 border">Duty Type</th>
                <th className="p-2 border">Time Slot</th>
                <th className="p-2 border">Date</th>
                <th className="p-2 border text-center">Edit</th>
                <th className="p-2 border text-center">Delete</th>
              </tr>
            </thead>
            <tbody>
              {assignments.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center p-4 text-gray-400">
                    No assignments added yet.
                  </td>
                </tr>
              ) : (
                assignments.map((item, index) => (
                  <tr key={index} className="border-t">
                    <td className="p-2 border">{item.patient}</td>
                    <td className="p-2 border">{item.nurse}</td>
                    <td className="p-2 border">
                      {item.dutyType.shift} - {item.dutyType.type}
                    </td>
                    <td className="p-2 border">{item.timeSlot}</td>
                    <td className="p-2 border">
                      {item.fromDate} to {item.toDate}
                    </td>
                    <td className="p-2 border text-center">
                      <button onClick={() => handleEdit(item, index)}>
                        <FiEdit color="blue" size={16} />
                      </button>
                    </td>
                    <td className="p-2 border text-center">
                      <button onClick={() => handleDelete(item, index)}>
                        <MdDeleteOutline color="red" size={16} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="text-center mt-6">
          <button
            className="bg-custom-gradient hover:bg-blue-600 text-white text-[12px] px-6 py-1 rounded shadow"
            onClick={Submit}
          >
            Done
          </button>
        </div>
      </div>
      {/* {toastMsg && <Toaster action={toastMsg.action} msg={toastMsg.msg} />} */}
    </div>
  );
};

export default StaffScheduling;
